import { CSSProperties } from "react";
import styles from "./spinner.module.scss";

interface SpinnerProps {
  size?: number;
  className?: string;
}

export function Spinner({ size, className }: SpinnerProps) {
  return (
    <div
      className={`${styles.spinner}${className ? ` ${className}` : ""}`}
      style={{ "--size": `${size ?? 80}px` } as CSSProperties}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

interface SpinnerContainerProps {
  className?: string;
}

export function SpinnerContainer({ className }: SpinnerContainerProps) {
  return (
    <div className={`${styles.container}${className ? ` ${className}` : ""}`}>
      <Spinner />
    </div>
  );
}

